// @flow
import React, { Component } from 'react';

// import withTrekEditPermission from "../../../HOCs/withTrekEditPermission";
type Props = {
  onEditPress: Function,
  iconClass: string,
  text: string,
};
class IconButton extends Component<Props> {
  render() {
    const { children, onEditPress, iconClass, text } = this.props;

    if (children) {
      return (
        <span>
          <a onClick={onEditPress}>{children}</a>
        </span>
      );
    }

    return (
      <span onClick={onEditPress} className="edit">
        <i className={`icon icon-hg-${iconClass}`} aria-hidden="true" /> {text}
      </span>
    );
  }
}

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/IconButton/IconButton.jsx